import { IFilterComp, IFilterParams, IDoesFilterPassParams } from "ag-grid-community";

interface HasRefundRequestsFilterParams extends IFilterParams {
  labelAll?: string;
  labelWithout?: string;
  labelWith?: string;
}

interface FilterModel {
  filterType: "set";
  values: ["true"] | ["false"];
}

export class HasRefundRequestsFilter implements IFilterComp {
  private params!: HasRefundRequestsFilterParams;
  private container!: HTMLElement;
  private selectedValue: "all" | "true" | "false" = "all";
  private hidePopup?: () => void;

  init(params: HasRefundRequestsFilterParams): void {
    this.params = params;

    this.container = document.createElement("div");
    this.container.className = "bg-white border border-gray-300 rounded p-2 min-w-[240px]";

    const group = document.createElement("div");
    group.className = "flex flex-col gap-2";

    group.append(
      this.buildRadioRow("all", params.labelAll || "All"),
      this.buildRadioRow("false", params.labelWithout || "Without refund requests"),
      this.buildRadioRow("true", params.labelWith || "With refund requests"),
    );

    this.container.appendChild(group);

    this.hidePopup = () => {
      requestAnimationFrame(() => {
        const filterMenu = this.container.closest(".ag-menu.ag-filter-menu");
        filterMenu?.remove();
      });
    };

    this.setModel(null);
  }

  getGui(): HTMLElement {
    return this.container;
  }

  afterGuiAttached(): void {
    this.syncRadios();
  }

  isFilterActive(): boolean {
    return this.selectedValue !== "all";
  }

  getModel(): FilterModel | null {
    if (!this.isFilterActive()) return null;
    return { filterType: "set", values: [this.selectedValue] as ["true"] | ["false"] };
  }

  setModel(model: FilterModel | null): void {
    const value = model?.values?.[0];
    this.selectedValue = value === "true" || value === "false" ? value : "all";
    this.syncRadios();
  }

  doesFilterPass(_params: IDoesFilterPassParams): boolean {
    return true;
  }

  private buildRadioRow(value: "all" | "true" | "false", label: string): HTMLElement {
    const row = document.createElement("label");
    row.className = "flex items-center gap-2 py-1 text-sm cursor-pointer select-none";

    const input = document.createElement("input");
    input.type = "radio";
    input.name = "has_refund_requests";
    input.value = value;
    input.checked = this.selectedValue === value;
    input.addEventListener("change", () => {
      if (!input.checked) return;
      this.selectedValue = value;
      this.params.filterChangedCallback();
      this.hidePopup?.();
    });

    const text = document.createElement("span");
    text.textContent = label;

    row.append(input, text);
    return row;
  }

  private syncRadios(): void {
    const radios = this.container.querySelectorAll<HTMLInputElement>('input[type="radio"][name="has_refund_requests"]');
    radios.forEach((radio) => (radio.checked = radio.value === this.selectedValue));
  }
}
